import LinkQueryParam from './LinkQueryParam';

export default LinkQueryParam;
